import { Navigate, Route, Routes } from "react-router-dom";

import { ORGANIZATIONS_PATH } from "./constants/organizationsAdmin.constants";
import OrganizationsListPage from "./pages/OrganizationsListPage";

/** Sub-router for `/app/organizations/*`: the staff directory of client organizations. */
export const OrganizationsNavigation = () => {
  return (
    <Routes>
      <Route index element={<OrganizationsListPage />} />
      <Route path="*" element={<Navigate to={ORGANIZATIONS_PATH} replace />} />
    </Routes>
  );
};
